import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import { Box, Button } from '@mui/material';
import { EmailOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import SlotCounter from 'react-slot-counter';

const Label = styled('span')({});
export const formatNumberByLang = (num, lang) => {
  const arabicDigits = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
  if (lang === 'ar') {
    return num
      .toString()
      .split('')
      .map((ch) => (/\d/.test(ch) ? arabicDigits[parseInt(ch, 10)] : ch))
      .join('');
  }
  return num.toString();
};

const Statistics = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const lang = i18n.language;

  return (
    <div style={{ marginLeft: '50px', marginRight: '50px' }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: '20px',
          marginTop: '30px',
          padding: '20px',
          border: '1px solid #f4f4f5',
          borderRadius: '5px',
          backgroundColor: '#f9f9f9ab',
          color: 'rgb(154,74,32)',
        }}
      >
        <div>
          <span
            style={{
              fontSize: '25px',
              fontWeight: 'bold',
              color: 'rgb(154,74,32)',
            }}
          >
            {formatNumberByLang(98, lang)}%
          </span>
          <p style={{ marginBottom: 0, color: '#7f6001' }}>
            {lang == 'ar' ? 'مستوى الرضا' : 'Level of satisfaction'}
          </p>
        </div>

        <div>
          <span
            style={{
              fontSize: '25px',
              fontWeight: 'bold',
              color: 'rgb(154,74,32)',
            }}
          >
            {formatNumberByLang(75, lang)}+
          </span>
          <p style={{ marginBottom: 0, color: '#7f6001' }}>{lang == 'ar' ? 'فئة المنتج' : 'Product Category'}</p>
        </div>

        <div>
          <span
            style={{
              fontSize: '25px',
              fontWeight: 'bold',
              color: 'rgb(154,74,32)',
            }}
          >
            {formatNumberByLang(13, lang)}+
          </span>
          <p style={{ marginBottom: 0, color: '#7f6001' }}>
            {lang == 'ar' ? 'الدول المصدر إليها':'Exporting Countries'}
          </p>
        </div>

        <div>
          <span
            style={{
              fontSize: '25px',
              fontWeight: 'bold',
              color: 'rgb(154,74,32)',
            }}
          >
            {formatNumberByLang(200000, lang)}
          </span>
          <p style={{ marginBottom: 0, color: '#7f6001' }}>
            {lang == 'ar' ? 'حجم الإنتاج السنوي':'Annual Production Volume'}
          </p>
        </div>

        <div>
          <span
            style={{
              fontSize: '25px',
              fontWeight: 'bold',
              color: 'rgb(154,74,32)',
            }}
          >
            {formatNumberByLang(40, lang)}+
          </span>
          <p style={{ marginBottom: 0, color: '#7f6001' }}>
            {lang == 'ar' ? 'سنوات الخبرة':'Years of Experience'}
          </p>
        </div>
      </Box>

      <div style={{ width: '100%', margin: '10px 5px', textAlign: 'end' }}>
        <Button
          onClick={() => navigate('/request-quote')}
          variant="outlined"
          sx={{
            gap: '5px',
            color: 'rgb(154,74,32)',
            borderColor: 'rgb(154,74,32)',
          }}
        >
          <EmailOutlined />
          {lang == 'ar' ? 'رسالة':'Message'}
        </Button>
      </div>
    </div>
  );
};

export default Statistics;
